import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../lib/firebase';

function LoginScreen({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const idToken = await userCredential.user.getIdToken();
      onLogin(userCredential.user, idToken);
    } catch (err) {
      if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
        setError('البريد الإلكتروني أو كلمة المرور غير صحيحة');
      } else if (err.code === 'auth/too-many-requests') {
        setError('محاولات كثيرة. الرجاء المحاولة لاحقاً');
      } else {
        setError('حدث خطأ. الرجاء المحاولة مرة أخرى');
      }
    }

    setLoading(false);
  };

  return (
    <div className="sd-login-page sd-dark">
      <div className="sd-login-card">
        <div className="sd-login-header">
          <img src="/images/rakeen-logo.png" alt="Rakeen" className="sd-login-logo" />
          <h1 className="sd-login-title">سريع</h1>
          <p className="sd-login-subtitle">تسجيل الدخول إلى لوحة التحكم</p>
        </div>

        <form className="sd-login-form" onSubmit={handleSubmit}>
          <div className="sd-login-field">
            <label>البريد الإلكتروني</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email@rakeen.cc"
              required
              dir="ltr"
            />
          </div>
          <div className="sd-login-field">
            <label>كلمة المرور</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              dir="ltr"
            />
          </div>

          {error && <div className="sd-login-error">{error}</div>}

          <button type="submit" className="sd-login-btn" disabled={loading}>
            {loading ? '...جاري الدخول' : 'تسجيل الدخول'}
          </button>
        </form>

        <p className="sd-login-footer">Rakeen — سريع</p>
      </div>
    </div>
  );
}

export default LoginScreen;
